import React from "react";
import { Box, Card, CardContent, Typography, Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Science,
  ShoppingCart,
  People,
  Assignment,
  AssignmentOutlined,
} from "@mui/icons-material";
import CustomAppBar from "../../components/AppBar";

const useStyles = makeStyles(() => ({
  root: { width: "100%", minHeight: "100vh", marginBottom: "-4rem" },
  container: { padding: "20px", maxWidth: "1200px", margin: "0 auto" },
  statsContainer: {
    display: "grid",
    gap: "20px",
    maxWidth: "900px",
    margin: "auto",
  },
  card: {
    padding: "16px",
    textAlign: "center",
    borderRadius: "12px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    cursor: "pointer",
  },
  title: {
    textAlign: "center",
    padding: "20px 0",
    borderRadius: "4px",
    marginBottom: "20px",
    border: "1px solid rgba(0, 0, 0, 0.12)",
  },
}));

const Biochar = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const navigate = useNavigate();

  const statsItems = [
    {
      label: t("Biochar Plant Interests"),
      icon: <Science sx={{ fontSize: 50 }} />,
      color: "#00BCD4",
      url: "/biochar-details",
    },
    {
      label: t("Biochar Procurements"),
      icon: <ShoppingCart sx={{ fontSize: 50 }} />,
      color: "#FFEB3B",
      url: "/biochar-procurements",
    },
    {
      label: t("Biochar Interests"),
      icon: <People sx={{ fontSize: 50 }} />,
      color: "#FF5722",
      url: "/biochar-forms",
    },
    {
      label: t("EBC Forms Summary"),
      icon: <AssignmentOutlined sx={{ fontSize: 50 }} />,
      color: "#4CAF50",
      url: "/biochar-forms",
    },
    {
      label: t("Biochar Sale Orders"),
      icon: <Assignment sx={{ fontSize: 50 }} />,
      color: "#2196F3", // Changed from #9C27B0 to a pleasant blue color
      url: "/biochar-orders",
    },
  ];

  return (
    <Box className={classes.root}>
      <CustomAppBar />

      <Box className={classes.container}>
        <Paper className={classes.title} elevation={0}>
          <Typography variant="h5">
            {t("Biochar Management Dashboard")}
          </Typography>
        </Paper>

        <Box className={classes.statsContainer}>
          {statsItems.map((stat, index) => (
            <Card
              key={index}
              className={classes.card}
              style={{ backgroundColor: stat.color }}
              onClick={() => navigate(stat.url)}
            >
              <CardContent>
                {stat.icon} {/* Display the icon */}
                <Typography sx={{ fontSize: 25 }} className={classes.label}>
                  {stat.label}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Biochar;
